import React, { useId } from 'react';
import styles from './PageSection.module.css';

interface PageSectionProps {
    title: string;
    children: React.ReactNode;
    actions?: React.ReactNode;
    /** Render as <fieldset>/<legend> instead of <section>/<h2> for grouped form controls. */
    asFieldset?: boolean;
}

const PageSection: React.FC<PageSectionProps> = ({ title, children, actions, asFieldset = false }) => {
    const headingId = useId();

    if (asFieldset) {
        return (
            <fieldset className={styles.section}>
                <legend className={styles.title}>{title}</legend>
                {actions && <div className={styles.actions}>{actions}</div>}
                <div className={styles.body}>{children}</div>
            </fieldset>
        );
    }

    return (
        <section className={styles.section} aria-labelledby={headingId}>
            <div className={styles.head}>
                <h2 id={headingId} className={styles.title}>
                    {title}
                </h2>
                {actions && <div className={styles.actions}>{actions}</div>}
            </div>
            <div className={styles.body}>{children}</div>
        </section>
    );
};

export default PageSection;
